import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvalidFile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 38,
	viewBox: "0 0 36 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24.7266 13.1016C24.8828 13.2969 25 13.5312 25 13.7656V14H20V9H20.2344C20.4688 9 20.7031 9.11719 20.8984 9.27344L24.7266 13.1016Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.0234 14.9766C18.8281 14.8203 18.75 14.5859 18.75 14.3125V9H10.9375C10.6641 9 10.4297 9.11719 10.2734 9.27344C10.0781 9.46875 10 9.70312 10 9.9375V28.0625C10 28.3359 10.0781 28.5703 10.2734 28.7266C10.4297 28.9219 10.6641 29 10.9375 29H24.0625C24.2969 29 24.5312 28.9219 24.7266 28.7266C24.8828 28.5703 25 28.3359 25 28.0625V15.25H19.6875C19.4141 15.25 19.1797 15.1719 19.0234 14.9766Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M17.9593 23.0462L8.52846 34.0141C8 34.6714 7.14634 34.9589 6.04878 34.9589C5.19512 34.9589 4.50407 34.7535 3.89431 34.3427C3.28455 33.932 3 33.4801 3 32.9872C3 32.6175 3.1626 32.2067 3.52846 31.7959L14.5041 18.9795L3.69106 6.32734C3.28455 5.8344 3.0813 5.38254 3.0813 4.93068C3.0813 4.43774 3.36585 3.98588 3.93496 3.5751C4.50407 3.16431 5.19512 3 5.96748 3C7.10569 3 7.95935 3.32863 8.48781 3.98588L18 14.9127L27.3902 4.02696C27.9594 3.3697 28.813 3 29.9106 3C30.7236 3 31.4553 3.20539 32.065 3.5751C32.6748 3.9448 33 4.43774 33 4.97176C33 5.34146 32.8374 5.71117 32.5528 6.08087L21.4553 19.0205L32.4715 31.9602C32.7561 32.2888 32.8781 32.6175 32.8781 32.9872C32.8781 33.5623 32.5935 34.0552 32.0244 34.4249C31.4553 34.7946 30.7642 35 29.9512 35C28.813 35 27.9594 34.6714 27.3902 34.0552L18 23.0462H17.9593Z",
			fill: "#F40F02"
		})
	]
});
export default SvgInvalidFile;
